import { gql } from '@apollo/client'

export const COACHING_LEAD_CREATE = gql`
  mutation coachingLeadCreate($params: CoachingLeadCreateRequest!) {
    CoachingLeadCreate(params: $params) {
      success
      message
      newLeadId
    }
  }
`

export const ADD_QUESTIONNAIRE_TO_LEAD = gql`
  mutation addQuestionnaireToLead(
    $id: ID!
    $answers: [CoachingLeadQuestionnaireInput!]!
  ) {
    addQuestionnaireToLead(inquiryId: $id, answers: $answers) {
      success
      message
    }
  }
`
